// extracted by mini-css-extract-plugin
export default {"root":"root__1SYK8","icon":"icon__VSAlQ","label":"label__71pwS"};